export enum TenantSortOption {
  NAME = "Name",
  START_DATE_CLOSEST = "Start Date (Closest)",
  START_DATE_FURTHEST = "Start Date (Furthest)",
  END_DATE_CLOSEST = "End Date (Closest)",
  END_DATE_FURTHEST = "End Date (Furthest)",
}
